import { render, staticRenderFns } from "./merchant-info.vue?vue&type=template&id=6cd5c75a&scoped=true&"
import script from "./merchant-info.vue?vue&type=script&setup=true&lang=ts&"
export * from "./merchant-info.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./merchant-info.vue?vue&type=style&index=0&id=6cd5c75a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd5c75a",
  null
  
)

export default component.exports